import type { SubscriptionTier } from '@/entities/subscription';

type UpgradeFeature = {
  name: string;
  description?: string;
  group?: string;
};

const TORQUE_IQ_GROUP = 'TorqueIQ';

const PRO_UPGRADE_FEATURES: UpgradeFeature[] = [
  { name: 'subscription.features.dvi' },
  { name: 'subscription.features.reports' },
  { name: 'subscription.features.labor_guide' },
  { name: 'subscription.features.gross_profit' },
  { name: 'subscription.features.time_tracking' },
  { name: 'subscription.features.inventory' },
];

const ELITE_UPGRADE_FEATURES: UpgradeFeature[] = [
  { name: 'subscription.features.sms' },
  { name: 'subscription.features.multi_location' },
  { name: 'subscription.features.tech_efficiency_report' },
  { name: 'subscription.features.ai_assistant', group: TORQUE_IQ_GROUP },
  { name: 'subscription.features.ai_summary', group: TORQUE_IQ_GROUP },
  { name: 'subscription.features.ai_suggested_jobs', group: TORQUE_IQ_GROUP },
];

export const getUpgradeFeatures = (tier: Exclude<SubscriptionTier, 'free'>): UpgradeFeature[] => {
  return tier === 'pro' ? PRO_UPGRADE_FEATURES : ELITE_UPGRADE_FEATURES;
};
